module.exports = __webpack_public_path__ + "img/finance_4.1d8572e2.png";